export default {
  state() {
    return {
      boCode: "",
      companyCd: ""
    };
  },
  getters: {
    get(state) {
      return state;
    }
  },
  mutations: {
    boCode(state, boCode) {
      state.boCode = boCode;
    },
    companyCd(state, companyCd) {
      state.companyCd = companyCd;
    }
  }
};
